import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterModule } from "@angular/router";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { GridFacade } from "@hermes/states/grid-filters-state";

import { FilterHatchService } from "../../services/filter-hatch-service/filter-hatch.service";

/**
 * Filter clear component -> Clear
 */
@Component({
    selector: "h-grid-filter-clear",
    templateUrl: "./grid-filter-clear.component.html",
    styleUrls: ["./grid-filter-clear.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, RouterModule, CallToActionComponent],
})
export class GridFilterClearComponent {
    constructor(
        public gridFacade: GridFacade,
        private filterHatchService: FilterHatchService,
    ) {}

    /**
     * Dispatch an event to be listened by the grid product
     */
    public onClearFilters(): void {
        this.gridFacade.clearFilters();
        this.filterHatchService.clearGridFilter();
    }
}
